<div class="contant-dialog">
    <form [formGroup]="formDialog">
        <div class="dialog-scroll-content">
            <div class="d-flex orang-title align-items-center">
                <i class="schedulePropeties-icon"></i>
                <div class="orang-text"> פרטי מערכת שעות וחגים</div>
                <div class="orang-line"></div>
            </div>
            <div>
                <div class="d-flex justify-content-between contant-inputs">
                    <div class="d-flex contant-inputs">
                        <div class="txt marginLeft10">תאריכים שנבחרו</div>
                        <div class="d-flex align-content-start flex-wrap dates-container">
                            <div *ngFor="let d of dates; let i = index" class="dateChecked d-flex align-items-center">
                                <div class="cancelDateButton">
                                    <button [disabled]="bySector" (click)="removeDate(d,i)">X</button>
                                </div>
                                <div class="txt"> {{d.str}}</div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="data.item" class="d-flex justify-content-between align-items-center contant-input ">
                        <div class="txt">סטטוס </div>
                        <input class="mrgRightInput inputText" formControlName="Status" type="text" disabled>
                        <button class="button-class save-button" (click)="openDialog()">לחץ לפירוט</button>
                    </div>
                </div>
                <div class="big-orang-line"></div>

                <div class="a contant-inputs">
                    <div class="b input-worp first-worp">
                        <div class="txt">תיאור התקופה
                            <div class="required">*</div>
                        </div>
                        <div class="selectDiv e">
                            <select formControlName="vacationType"
                                [ngClass]="{required: isSubmited && formDialog.controls.vacationType.errors}"
                                (change)="checkChosen($event)" class="input-a">
                                <option value=""></option>
                                <option *ngFor="let d of calendarSvc.PeriodDescriptionList" [ngValue]="d">
                                    {{ d.viewValue }}
                                </option>
                            </select>
                        </div>
                        <input formControlName="description" placeholder="פירוט *" *ngIf="elseChosen"
                            class="inputText input-b " type="text"
                            [ngClass]="{required: isSubmited && formDialog.controls.description.errors}">
                    </div>
                    <div class="d input-worp first-worp">
                        <div class="custom-control custom-switch custom-switch-xl">
                            <input type="checkbox" (change)="OnSwitch($event.target.checked)"
                                class="custom-control-input" id="customSwitch1" formControlName="isShortDay">
                            <label class="custom-control-label" for="customSwitch1">יום קצר</label>
                        </div>
                    </div>

                </div>
                <div>
                    <div class="d-flex orang-title align-items-center">
                        <i class="scheduleHours-icon"></i>
                        <div class="orang-text">שעת פיזור</div>
                        <div class="orang-line"></div>
                    </div>
                    <div>
                        <div class="d-flex justify-content-between contant-inputs">
                            <div class="d-flex justify-content-between input-worp">
                                <div class="txt">שעת פיזור
                                    <div class="required">*</div>
                                </div>
                                <div class="selectDiv">
                                    <select formControlName="endTime"
                                        [ngClass]="{required: isSubmited && formDialog.controls.endTime.errors}"
                                        [attr.disabled]="formDialog.value.isShortDay == false ? '' : null">
                                        <option value=""></option>
                                        <option [ngValue]="endHour"
                                            *ngFor="let endHour of calendarSvc.ScheduleHoursList">
                                            {{ endHour.viewValue }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="big-orang-line"></div>

                <div class="a contant-inputs upload-file">
                    <div class="b input-worp first-worp">
                        <label for="fileUpload" class="upload-button-style save-button button-class">
                            <span>העלה קובץ</span>
                            <input id="fileUpload" type="file" multiple (change)="onFilesSelected($event)"
                                accept=".pdf,.doc,.docx,.txt,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.eml,.msg,.zip,.rar,.ppt,.pptx" />
                        </label>

                        <button type="button" class="upload-button-style save-button button-class"
                            (click)="addStandaloneNote()" style="margin-right: 10px;"
                            [disabled]="standaloneNotes.length >= 1 || hasExistingStandaloneNote()"
                            [ngClass]="{'disabledButton': standaloneNotes.length >= 1 || hasExistingStandaloneNote()}">
                            <span>הוסף הערה</span>
                        </button>
                    </div>

                    <div class="uploaded-files-list" [formGroup]="formDialog">
                        <div *ngFor="let f of existingFiles; let i = index" class="file-item">
                            <a (click)="downloadFile(f.FileId, f.FileName)" class="download-link">{{ f.FileName }}</a>
                            <textarea [value]="f.Note" (input)="existingFiles[i].Note = $event.target.value"
                                placeholder="הערה לקובץ" rows="2" class="comment-box"></textarea>
                        </div>

                        <div *ngFor="let f of newFiles; let i = index" class="file-item">
                            <span>{{ f.FileName }}</span>
                            <textarea [value]="f.Note" (input)="newFiles[i].Note = $event.target.value"
                                placeholder="הערה לקובץ" rows="2" class="comment-box"></textarea>
                        </div>
                        <div *ngFor="let note of standaloneNotes; let i = index" class="file-item standalone-note">
                            <div class="standalone-note-header">
                                <span class="standalone-note-title">הערה</span>
                            </div>
                            <textarea [value]="note.Note" (input)="standaloneNotes[i].Note = $event.target.value"
                                placeholder="הזן הערה" rows="3" class="comment-box"></textarea>
                        </div>

                    </div>
                </div>

                <div class="contant-buttons d-flex justify-content-end">

                    <button class="cancel-save-button" (click)="close()">
                        <span *ngIf="!bySector">ביטול</span>
                        <span *ngIf="bySector">סגור</span>
                    </button>
                    <!-- <button class="save-button" (click)="save()">
                    <span>שמור</span>
                </button> -->

                    <button *ngIf="!bySector" class="save-button buttonload" (click)="save()"
                        [ngClass]="{disabledButton: bySector}" [disabled]="bySector">
                        <i [hidden]="!loading" class="fa fa-spinner fa-spin"></i>שמור
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>